// Pure chat utilities — no React, safe to import in Node.js tests.

export const HISTORY_PAIR_LIMIT = 10 // pairs sent to the LLM (20 messages)
export const DISPLAY_PAIR_LIMIT = 10 // pairs shown before auto-collapse in the UI

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
}

// Returns the last N conversation pairs from a history array.
// A pair is one user message followed by one assistant message.
// When history is within the limit it is returned unchanged (same reference).
export function trimHistory(history: ChatMessage[], pairLimit: number): ChatMessage[] {
  const maxMessages = pairLimit * 2
  if (history.length <= maxMessages) return history
  return history.slice(history.length - maxMessages)
}
